import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { TranslationKeys } from 'src/interfaces/translation';

import { getLang } from './lang';

const langs = ['en', 'zh-TW'];
export const commonNamespaces: TranslationKeys[] = ['footer', 'header', 'translation'];

const allNameSpaces: TranslationKeys[] = [
  'footer',
  'header',
  'index',
  'my-page',
  'pricing',
  'privacy-policy',
  'schedule',
  'terms-of-use',
  'translation',
  'user',
];

const getResouces = async (namespaces: TranslationKeys[] = allNameSpaces) => {
  const resources: Record<string, Record<string, string>> = {};
  const allPromises: Promise<void>[] = [];
  for (let i = 0; i < langs.length; i++) {
    const lang = langs[i];
    resources[lang] = {};
    for (let j = 0; j < namespaces.length; j++) {
      const namespace = namespaces[j];
      const promise = new Promise<void>((resolve) => {
        import(`src/i18n/${lang}/${namespace}.json`).then((res) => {
          resources[lang][namespace] = res.default;
          resolve();
        });
      });
      allPromises.push(promise);
    }
  }
  await Promise.allSettled(allPromises);
  return resources;
};

const setUpTranslation = async (namespaces: TranslationKeys[] = allNameSpaces) => {
  const resources = await getResouces(namespaces);
  const lang = getLang();
  i18n.use(initReactI18next).init({
    resources,
    lng: lang,
    fallbackLng: 'en',
    ns: namespaces,
    defaultNS: 'translation',
    load: 'currentOnly',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
  });
};

export default setUpTranslation;
